module.exports = __webpack_public_path__ + "dimer/static/img/DrKL.b8e1830.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DrKL.jpg
// module id = GII8
// module chunks = 0